export default __webpack_public_path__ + "static/media/6.b3f24da9.jpg";